import ddt from '@wix/da-ddt';
import { StreamType } from './types';
import { fetch as offsetFetch } from './withOffset/actions';
import { fetch as cursorFetch } from './withCursor/actions';
import { fetch as paginatedFetch } from './withPagination/actions';
export function getFetchActionForStreamType(type) {
    switch (type) {
        case StreamType.WITH_OFFSET:
            return offsetFetch;
        case StreamType.WITH_CURSOR:
            return cursorFetch;
        case StreamType.WITH_PAGINATION:
            return paginatedFetch;
        default:
            ddt.warn('stream', 'Unknown stream type', type);
            return function (streamId) {
                return ({ streamId: streamId, type: 'STREAM__UNKNOWN_TYPE__FETCH' });
            }; // no idea what this type is, noop
    }
}
//# sourceMappingURL=helpers.js.map